import dynamic from 'next/dynamic';
import { CoBrandCardProps } from './CoBrandCard.types';

export const CoBrandCard = dynamic<CoBrandCardProps>(() => import('./CoBrandCard'));